<template>
  <div class="swiper-container">
    <swiper
      class="swiper"
      ref="mySwiper"
      :options="swiperOptions"
      >
      <swiper-slide  v-for="(slide, index) in slideImageList" :key="index">
        <img :src="slide.src" alt="slide" class="slide-img">
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css' // 引入 Swiper 样式
  

  export default {
    name: 'AwardsSwiper',
    components: {
      Swiper,
      SwiperSlide
    },
    data(){
      return {
        slideImageList: [
          {
            src: require('../assets/license/binzhou.jpg')
          },
          {
            src: require('../assets/license/changchun.png')
          },
          {
            src: require('../assets/license/changzhou.jpg')
          },
          {
            src: require('../assets/license/fuzhou.jpg')
          },
          {
            src: require('../assets/license/hengshui.jpg')
          },
          {
            src: require('../assets/license/huzhou.jpg')
          },
          {
            src: require('../assets/license/jinan.jpg')
          },
          {
            src: require('../assets/license/jingdezhen.png')
          },
          {
            src: require('../assets/license/jinhua.png')
          },
          {
            src: require('../assets/license/lianyungang.jpg')
          },
          {
            src: require('../assets/license/liaocheng.jpg')
          },
          {
            src: require('../assets/license/linfen.jpg')
          },
          {
            src: require('../assets/license/luoyang.jpg')
          },
          {
            src: require('../assets/license/nantong.jpg')
          },
          {
            src: require('../assets/license/qingdao.jpg')
          },
          {
            src: require('../assets/license/qiqihaer.jpg')
          },
          {
            src: require('../assets/license/sanya.jpg')
          },
          {
            src: require('../assets/license/shangrao.jpg')
          },
          {
            src: require('../assets/license/tianjin.jpg')
          },
          {
            src: require('../assets/license/taizhou.jpg')
          },
          {
            src: require('../assets/license/weifang.jpg')
          },
          {
            src: require('../assets/license/xuzhou.jpg')
          },
          {
            src: require('../assets/license/yantai.jpg')
          },
          {
            src: require('../assets/license/zibo.jpg')
          },
        ],
        swiperOptions: {
          slidesPerView: 5, // 设置可见幻灯片数量
          centeredSlides: true, // 中心化幻灯片
          spaceBetween: 0, // 负值可以让幻灯片部分重叠
          loop: true, // 循环模式选项
          autoplay: {
            delay: 2500, // 自动切换的时间间隔
            disableOnInteraction: false, // 用户操作后是否停止自动播放
          },
          on: {
            slideChangeTransitionStart: function () {
              // 可以在这里添加额外的逻辑
            }
          }
        }
      }
    },
    mounted(){
    },
    methods: {
      
    }
  }
</script>

<style lang="scss" scoped>
.swiper-container {
  width: 100%;
}

.slide-img {
  height: 18.5vw;
  width: 26vw;
  display: block;
  margin: 0 auto;
  transition: transform 1s ease;
  border: 10px solid #734028;
  border-radius: 10px;
}

/* 为中间的图片设置最大的尺寸，并应用z-index保证它位于最上层 */
.swiper-slide-active .slide-img {
  height: 24vw;
  width: 34vw;
  z-index: 10;
}
.swiper-slide.swiper-slide-active {
  justify-content: center;
}

/* 为临近中间图片的两侧图片设置稍小的尺寸 */
.swiper-slide-next .slide-img,
.swiper-slide-prev .slide-img {
  height: 22vw;
  width: 30vw;
  z-index: 9;
}
.swiper-slide.swiper-slide-next,
.swiper-slide.swiper-slide-prev {
  justify-content: center;
}

.swiper-slide-next + .swiper-slide {
  justify-content: flex-end;
}

/* 确保所有图片都底部对齐 */
.swiper-slide {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  height: 24vw;
  width: 17vw;
}
</style>